import { toastError } from "../../shared/components/ToastContainer";
import { log, logE } from "../../shared/services/debug-logger";
import { errorLogger } from "../../shared/services/error-logger";
import { api, apiUrl } from "../../shared/services/service";
import { TechForm } from "../../tech-form/models/tech-form.model";

export async function getPendingBalticForms() {
  const result = await api.get(`${apiUrl}/extUserAssignedBalticForm`, {
    params: {
      page: 1,
    },
  });

  var forms = result.data.data?.sort(
    (a: TechForm, b: TechForm) => new Date(b.REQUESTED_ON).getTime() - new Date(a.REQUESTED_ON).getTime(),
  );

  forms?.forEach((form: TechForm) => (form.TYPE = "BALTIC"));

  log("REPO - getPendingBalticForms - result", { count: forms?.length ?? 0 });
  return forms;
}

export async function getCompletedBalticForms() {
  const result = await api.get(`${apiUrl}/extUserAssignedBalticFormStatus`, {
    params: {
      page: 1,
    },
  });

  var forms = result.data.data;

  forms?.forEach((form: TechForm) => (form.TYPE = "BALTIC"));

  log("REPO - getCompletedBalticForms - result", { count: forms?.length ?? 0 });
  return forms;
}

export const removeBalticFormLocalStorage = () => {
  Object.keys(localStorage)
    .filter((key) => key.endsWith("Form"))
    .forEach((key) => {
      localStorage.removeItem(key);
    });
};

export const saveBq1GenInfo = async (imoNumber: string | undefined, vesselName: string | undefined, _form: any) => {
  log("SERV - saveBq1GenInfo", { imoNumber });
  const section = "Baltic Questionnaire Page 1 General Info";
  errorLogger.clearErrorBySection(section);
  try {
    await api.post(`${apiUrl}/bq_GeneralInfo`, _form, {
      params: { imoNumber, vesselName },
    });
    log("SERV - saveBq1GenInfo - saved");
  } catch (error: any) {
    let message = "Error saving Baltic Questionnaire Page 1 General Info";
    if (error.response?.status === 404) {
      message = "Error saving Baltic Questionnaire Page 1 General Info - EP not found (404)";
      errorLogger.log(section, message, "BQ");
      log("SERV - saveBq1GenInfo - unavailable", { status: 404 });
      toastError(message);
    } else {
      errorLogger.log(section, message, "BQ");
      logE(new Error("SERV - saveBq1GenInfo - failed"));
      toastError(message);
    }
  }
};

export const saveBq2Certification = async (
  imoNumber: string | undefined,
  vesselName: string | undefined,
  _form: any,
) => {
  log("SERV - saveBq2Certification", { imoNumber });
  const section = "Baltic Questionnaire Page 2 Cerfication";
  errorLogger.clearErrorBySection(section);
  try {
    await api.post(`${apiUrl}/bq_Certification`, _form, {
      params: { imoNumber, vesselName },
    });
    log("SERV - saveBq2Certification - saved");
  } catch (error: any) {
    let message = "Error saving Baltic Questionnaire Page 2 Certification";
    if (error.response?.status === 404) {
      message = "Error saving Baltic Questionnaire Page 2 Certification - EP not found (404)";
      errorLogger.log(section, message, "BQ");
      log("SERV - saveBq2Certification - unavailable", { status: 404 });
      toastError(message);
    } else {
      errorLogger.log(section, message, "BQ");
      logE(new Error("SERV - saveBq2Certification - failed"));
      toastError(message);
    }
  }
};

export const saveBq3CrewManagement = async (
  imoNumber: string | undefined,
  vesselName: string | undefined,
  _form: any,
) => {
  log("SERV - saveBq3CrewManagement", { imoNumber });
  const section = "Baltic Questionnaire Page 3 Crew Management";
  errorLogger.clearErrorBySection(section);
  try {
    await api.post(`${apiUrl}/bq_CrewManagement`, _form, {
      params: { imoNumber, vesselName },
    });
    log("SERV - saveBq3CrewManagement - saved");
  } catch (error: any) {
    let message = "Error saving Baltic Questionnaire Page 3 Crew Management";
    if (error.response?.status === 404) {
      message = "Error saving Baltic Questionnaire Page 3 Crew Management - EP not found (404)";
      errorLogger.log(section, message, "BQ");
      log("SERV - saveBq3CrewManagement - unavailable", { status: 404 });
      toastError(message);
    } else {
      errorLogger.log(section, message, "BQ");
      logE(new Error("SERV - saveBq3CrewManagement - failed"));
      toastError(message);
    }
  }
};

export const saveBq4SafetyManagement = async (
  imoNumber: string | undefined,
  vesselName: string | undefined,
  _form: any,
) => {
  log("SERV - saveBq4SafetyManagement", { imoNumber });
  const section = "Baltic Questionnaire Page 4 Safety Management";
  errorLogger.clearErrorBySection(section);
  try {
    await api.post(`${apiUrl}/bq_SafetyManagement`, _form, {
      params: { imoNumber, vesselName },
    });
    log("SERV - saveBq4SafetyManagement - saved");
  } catch (error: any) {
    let message = "Error saving Baltic Questionnaire Page 4 Safety Management";
    if (error.response?.status === 404) {
      message = "Error saving Baltic Questionnaire Page 4 Safety Management - EP not found (404)";
      errorLogger.log(section, message, "BQ");
      log("SERV - saveBq4SafetyManagement - unavailable", { status: 404 });
      toastError(message);
    } else {
      errorLogger.log(section, message, "BQ");
      logE(new Error("SERV - saveBq4SafetyManagement - failed"));
      toastError(message);
    }
  }
};

export const saveBq5CargoArrangements = async (
  imoNumber: string | undefined,
  vesselName: string | undefined,
  _form: any,
) => {
  log("SERV - saveBq5CargoArrangements", { imoNumber });
  const section = "Baltic Questionnaire Page 5 Cargo Arrangements";
  errorLogger.clearErrorBySection(section);
  try {
    await api.post(`${apiUrl}/bq_CargoArrangements`, _form, {
      params: { imoNumber, vesselName },
    });
    log("SERV - saveBq5CargoArrangements - saved");
  } catch (error: any) {
    let message = "Error saving Baltic Questionnaire Page 5 Cargo Arrangements";
    if (error.response?.status === 404) {
      message = "Error saving Baltic Questionnaire Page 5 Cargo Arrangements - EP not found (404)";
      errorLogger.log(section, message, "BQ");
      log("SERV - saveBq5CargoArrangements - unavailable", { status: 404 });
      toastError(message);
    } else {
      errorLogger.log(section, message, "BQ");
      logE(new Error("SERV - saveBq5CargoArrangements - failed"));
      toastError(message);
    }
  }
};

export const saveBq6CargoGear = async (imoNumber: string | undefined, vesselName: string | undefined, _form: any) => {
  log("SERV - saveBq6CargoGear", { imoNumber });
  const section = "Baltic Questionnaire Page 6 Cargo Gear";
  errorLogger.clearErrorBySection(section);
  try {
    await api.post(`${apiUrl}/bq_CargoGear`, _form, {
      params: { imoNumber, vesselName },
    });
    log("SERV - saveBq6CargoGear - saved");
  } catch (error: any) {
    let message = "Error saving Baltic Questionnaire Page 6 Cargo Gear";
    if (error.response?.status === 404) {
      message = "Error saving Baltic Questionnaire Page 6 Cargo Gear - EP not found (404)";
      errorLogger.log(section, message, "BQ");
      log("SERV - saveBq6CargoGear - unavailable", { status: 404 });
      toastError(message);
    } else {
      errorLogger.log(section, message, "BQ");
      logE(new Error("SERV - saveBq6CargoGear - failed"));
      toastError(message);
    }
  }
};

export const saveBq7Container = async (imoNumber: string | undefined, vesselName: string | undefined, _form: any) => {
  log("SERV - saveBq7Container", { imoNumber });
  const section = "Baltic Questionnaire Page 7 Container Bulkers";
  errorLogger.clearErrorBySection(section);
  try {
    await api.post(`${apiUrl}/bq_Container`, _form, {
      params: { imoNumber, vesselName },
    });
    log("SERV - saveBq7Container - saved");
  } catch (error: any) {
    let message = "Error saving Baltic Questionnaire Page 7 Container Bulkers";
    if (error.response?.status === 404) {
      message = "Error saving Baltic Questionnaire Page 7 Container Bulkers - EP not found (404)";
      errorLogger.log(section, message, "BQ");
      log("SERV - saveBq7Container - unavailable", { status: 404 });
      toastError(message);
    } else {
      errorLogger.log(section, message, "BQ");
      logE(new Error("SERV - saveBq7Container - failed"));
      toastError(message);
    }
  }
};

export const saveBq8Mooring = async (imoNumber: string | undefined, vesselName: string | undefined, _form: any) => {
  log("SERV - saveBq8Mooring", { imoNumber });
  const section = "Baltic Questionnaire Page 8 Mooring";
  errorLogger.clearErrorBySection(section);
  try {
    await api.post(`${apiUrl}/bq_Mooring`, _form, {
      params: { imoNumber, vesselName },
    });
    log("SERV - saveBq8Mooring - saved");
  } catch (error: any) {
    let message = "Error saving Baltic Questionnaire Page 8 Mooring";
    if (error.response?.status === 404) {
      message = "Error saving Baltic Questionnaire Page 8 Mooring - EP not found (404)";
      errorLogger.log(section, message, "BQ");
      log("SERV - saveBq8Mooring - unavailable", { status: 404 });
      toastError(message);
    } else {
      errorLogger.log(section, message, "BQ");
      logE(new Error("SERV - saveBq8Mooring - failed"));
      toastError(message);
    }
  }
};

export const saveBq9EngineRoom = async (imoNumber: string | undefined, vesselName: string | undefined, _form: any) => {
  log("SERV - saveBq9EngineRoom", { imoNumber });
  const section = "Baltic Questionnaire Page 9 Engine Room";
  errorLogger.clearErrorBySection(section);
  try {
    await api.post(`${apiUrl}/bq_EngineRoom`, _form, {
      params: { imoNumber, vesselName },
    });
    log("SERV - saveBq9EngineRoom - saved");
  } catch (error: any) {
    let message = "Error saving Baltic Questionnaire Page 9 Engine Room";
    if (error.response?.status === 404) {
      message = "Error saving Baltic Questionnaire Page 9 Engine Room - EP not found (404)";
      errorLogger.log(section, message, "BQ");
      log("SERV - saveBq9EngineRoom - unavailable", { status: 404 });
      toastError(message);
    } else {
      errorLogger.log(section, message, "BQ");
      logE(new Error("SERV - saveBq9EngineRoom - failed"));
      toastError(message);
    }
  }
};

export const saveBq10Miscellaneous = async (
  imoNumber: string | undefined,
  vesselName: string | undefined,
  _form: any,
) => {
  log("SERV - saveBq10Miscellaneous", { imoNumber });
  const section = "Baltic Questionnaire Page 10 Miscellaneous";
  errorLogger.clearErrorBySection(section);
  try {
    await api.post(`${apiUrl}/bq_Miscellaneous`, _form, {
      params: { imoNumber, vesselName },
    });
    log("SERV - saveBq10Miscellaneous - saved");
  } catch (error: any) {
    let message = "Error saving Baltic Questionnaire Page 10 Miscellaneous";
    if (error.response?.status === 404) {
      message = "Error saving Baltic Questionnaire Page 10 Miscellaneous - EP not found (404)";
      errorLogger.log(section, message, "BQ");
      log("SERV - saveBq10Miscellaneous - unavailable", { status: 404 });
      toastError(message);
    } else {
      errorLogger.log(section, message, "BQ");
      logE(new Error("SERV - saveBq10Miscellaneous - failed"));
      toastError(message);
    }
  }
};
